// reserva-pdf-service.ts
import { Injectable } from '@angular/core';
import { ReservaService } from '../reserva.service';
import { jsPDF } from 'jspdf';
import { WatermarkService} from '../exportar/watermark.service';

@Injectable({
  providedIn: 'root'
})
export class ReservaPdfService {
  constructor(private reservaService: ReservaService, private watermarkService: WatermarkService) {}

  generateReservaPdf(reservaId: number): void {
    this.reservaService.getReservaSimplificadaById(reservaId).subscribe(reserva => {
      this.createPDF(reserva);
    });
  }

  private createPDF(reserva: any): void {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    this.watermarkService.addWatermark(doc, `${window.location.origin}/assets/logo.png`, pageWidth, pageHeight)
      .then(() => {
        this.generatePDFContent(doc, reserva, pageWidth, pageHeight);
      })
      .catch(() => {
        this.generatePDFContent(doc, reserva, pageWidth, pageHeight);
      });
  }
  private generatePDFContent(doc: jsPDF, reserva: any, pageWidth: number, pageHeight: number): void {
    try {
      // Título principal
      let y = 20;
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text('COMPROBANTE DE RESERVA', pageWidth / 2, y, { align: 'center' });

      // Número de recibo
      y += 15;
      doc.setFontSize(14);
      doc.text('N° Recibo', pageWidth / 2, y, { align: 'center' });
      y += 24;
      doc.setFontSize(60);
      doc.text(reserva.num_recibo.padStart(4, '0'), pageWidth / 2, y, { align: 'center' });

      y += 12;
      doc.setFontSize(11);
      doc.setFont('helvetica', 'normal');
      doc.text(`Empresa: ${reserva.razon_social}`, pageWidth / 2, y, { align: 'center' });
      y += 8;
      doc.text(`RUC: ${reserva.ruc}`, pageWidth / 2, y, { align: 'center' });
      y += 8;
      doc.text(`Celular: ${reserva.celular}`, pageWidth / 2, y, { align: 'center' });
      y += 8;
      doc.text(`Tipo: ${reserva.tipo_institucion}`, pageWidth / 2, y, { align: 'center' });

      // Línea divisora
      y += 15;
      doc.setLineWidth(0.5);
      doc.line(15, y, pageWidth - 15, y);


      y += 15;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);
      doc.text(`Campo: ${reserva.campo}`, pageWidth / 2, y, { align: 'center' });
      y += 8;
      doc.text(`Fecha: ${this.formatDate(reserva.fechaReserva)}`, pageWidth / 2, y, { align: 'center' });
      y += 8;
      doc.text(`Inicio: ${reserva.horarioInicio} | Fin: ${reserva.horarioFin}`, pageWidth / 2, y, { align: 'center' });

      // Línea divisora
      y += 15;
      doc.line(15, y, pageWidth - 15, y);

      doc.setFontSize(14);
      y += 15;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);
      doc.text(`Total: S/ ${this.formatCurrency(reserva.total)}`, pageWidth / 2, y, { align: 'center' });
      y += 8;
      doc.text(`Descuento: ${reserva.descuento}%`, pageWidth / 2, y, { align: 'center' });
      y += 8;
      doc.text(`Motivo: ${reserva.motivo_descuento || 'No aplica'}`, pageWidth / 2, y, { align: 'center' });

      doc.save(`Comprobante_Reserva_${reserva.num_recibo}.pdf`);
    } catch (error) {
      console.error('Error al generar el contenido del PDF:', error);
      throw new Error('No se pudo generar el PDF');
    }
  }

  private formatDate(date: string): string {
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
  }

  private formatCurrency(value: number): string {
    return value ? value.toFixed(2) : '0.00';
  }
}
